import React, { useState } from 'react';
import Toggle from './Toggle';
import Menubar from './Menubar';
import { Link } from 'react-router-dom';

import './Navbar.css';

import logo from '../../media/logo1.svg';

const Navbar = () => {
  const [menuState, setMenuState] = useState('');
  const handleClick = (value) => {
    if (value === 0) {
      setMenuState('open');
    } else {
      setMenuState('close');
    }
  };
  return (
    <React.Fragment>
      <div className='navbar'>
        <Link to='/'>
          {/* <a> */}
          <div className='navbar-logo'>
            <img src={logo} alt='logo' />
          </div>
          {/* </a> */}
        </Link>
        <div className='navbar-list-container'>
          <ul className='navbar-list'>
            <Link to='/hirealawyer'>
              {/* <a> */}
              <li className='navbar-list-item'>Hire a Lawyer</li>
              {/* </a> */}
            </Link>
            <Link to='/asktheexpert'>
              {/* <a> */}
              <li className='navbar-list-item'>Ask the Expert</li>
              {/* </a> */}
            </Link>
            <Link to='/registeraslawyer'>
              {/* <a> */}
              <li className='navbar-list-item'>Register as Lawyer</li>
              {/* </a> */}
            </Link>
          </ul>
          <div className='navbar-connect'>
            <a href='/login' className='login'>
              <li>Login</li>
            </a>

            <a href='/signup' className='signup'>
              <li>Sign Up</li>
            </a>
          </div>
        </div>
        <div className='navbar-gettheapp'>
          <a href='/gettheapp'>
            <span>Get the App</span>
          </a>
        </div>
        <Toggle click={handleClick} />
      </div>
      <Menubar menubarState={menuState} />
    </React.Fragment>
  );
};

export default Navbar;
